import PropTypes from 'prop-types';
import Radio from '../Radio/Radio';

const GroupRadio = ({
  defaultValue,
  items,
  error,
  dataTest,
  onChange,
  required,
  disabled,
  onBlur
}) => {
  const handleChange = ({ target: { value } }) => {
    onChange(value);
  };

  return (
    <>
      <div className="inline-flex">
        {items.map(({ label, value, id }) => {
          return (
            <Radio
              key={`${id}-${label}`}
              label={label}
              value={value}
              id={id}
              dataTest={`${dataTest}-${value}`}
              onChange={handleChange}
              onBlur={onBlur}
              required={required}
              disabled={disabled}
              error={error}
              checked={value === defaultValue}
            />
          );
        })}
      </div>
      {error ? (
        <small
          data-testid={`${dataTest}-error`}
          className="font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
        >
          {error}
        </small>
      ) : null}
    </>
  );
};

GroupRadio.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  dataTest: PropTypes.string.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired
};

export default GroupRadio;
